import { FC } from 'react';

import { IconProps } from './types';

export const CloseIcon: FC<IconProps> = ({ color = '#B6BECC', height = 24, size, width = 24 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M2.419 21.586a1.45 1.45 0 0 0 1.01.414 1.45 1.45 0 0 0 1.01-.414l7.56-7.57 7.56 7.57a1.45 1.45 0 0 0 1.01.414 1.45 1.45 0 0 0 1.01-.414 1.437 1.437 0 0 0 0-2.028l-7.56-7.556 7.56-7.556a1.437 1.437 0 0 0 0-2.028 1.43 1.43 0 0 0-2.02 0l-7.56 7.57-7.56-7.57a1.43 1.43 0 0 0-2.02 0 1.437 1.437 0 0 0 0 2.028l7.56 7.556-7.56 7.556a1.437 1.437 0 0 0 0 2.028Z"
		/>
	</svg>
);
